var map = {
	"./Doctor_1.webp": 2613,
	"./Doctor_2.webp": 7118,
	"./Doctor_3.webp": 8683,
	"./Doctor_4.webp": 917,
	"./bg-3.webp": 82,
	"./bg-footer.webp": 3632,
	"./bsn-medical.svg": 9896,
	"./card_img_1.webp": 8245,
	"./card_img_2.webp": 1151,
	"./card_img_3.webp": 1289,
	"./doc_1.png": 4620,
	"./doc_2.png": 4447,
	"./doc_3.png": 72,
	"./doc_4.png": 2022,
	"./doc_5.png": 7255,
	"./person_1.webp": 7601,
	"./person_2.webp": 26,
	"./slider_images/1.png": 3037,
	"./slider_images/2.png": 6645,
	"./slider_images/3.png": 6223,
	"./slider_images/4.png": 7224,
	"./slider_images/5.png": 2860,
	"./slider_images/6.png": 5590,
	"./thumb.webp": 2065,
	"./video_2.webp": 6549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;